import './style.css'
import React, {
	useEffect
}from 'react'
import {
	Modal, Pagination, Table
}from 'antd'
import CustomButton from '../../../components/CustomButton'
import Scrollbars from 'react-custom-scrollbars'

const ModalAudit = (props) => {
	const { visible, setVisible, data, columns, setPage, count, setIdRecordAudit, tableProps, ...otherProps } = props

	const onPaginationChange = (value) => {
		setPage(value)
	}

	const handleCancel = () => {
		setVisible(false)
		setIdRecordAudit(null)
	}

	return (<>
		<Modal
			destroyOnClose
			footer={
				(<>
					<CustomButton
						type="grey"
						onClick={ handleCancel }
					>
          Закрыть
					</CustomButton>
				</>)
			}
			title="История изменений"
			visible={ visible }
			width={ 1200 }
			onCancel={ handleCancel }
			{ ...otherProps }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 600 }
			>
				<Table
					columns={ columns }
					dataSource={ data }
					pagination={ false }
					{ ...tableProps }
				>
				</Table>

				{ count > 10 && <div className="modal-audit-pagination">
					<Pagination
						showQuickJumper
						total={ count }
						onChange={ onPaginationChange }
					/>
				</div> }
			</Scrollbars>
		</Modal>
	</>)
}

export default ModalAudit